module.exports = __webpack_public_path__ + "img/Group-23.6d98710c.png";